<template>
  <v-dialog v-model="showing_modal" eager max-width="600">
    <v-card>
      <v-form
        ref="form"
        v-model="form_status"
        v-on:submit.prevent="add_form_validate"
      >
        <v-card-title class="headline">
          {{ $t("officer_config.config_project") }} (
          {{
            form_mode === FORM_MODES.ADD
              ? $t("officer_config.addnew")
              : form_mode === FORM_MODES.EDIT
              ? $t("officer_config.edit")
              : $t("officer_config.copy")
          }}
          )
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="config_year_id"
            :label="$t('officer_config.academic_year')"
            :items="listFilter(years, level_id, 'LEVEL_ID')"
            :item-value="(item) => item.YEAR_ID"
            :item-text="(item) => item.SEMESTER + ' / ' + item.YEAR"
            :rules="requiredRules"
            @change="(year_id) => select_year(year_id)"
            outlined
          ></v-autocomplete>
          <v-autocomplete
            v-model="config_round_id"
            :label="$t('officer_config.round_number_name')"
            :items="listFilter(rounds, config_year_id, 'YEAR_ID')"
            :item-value="(item) => item.ROUND_ID"
            :item-text="
              (item) =>
                item.ROUND_NUMBER + ' - ' + objectTranslator(item, 'NAME')
            "
            :rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <!-- <v-text-field
            v-model="config_project_code"
            :label="$t('officer_config.project_code')"
            disabled
            outlined
            dense
          ></v-text-field> -->
          <div class="mb-6" v-if="form_mode === FORM_MODES.COPY">
            <h5>คัดลอกจากโครงการ</h5>
            <p>
              #{{ config_from_project_id }} -
              {{ config_from_project_name }}
            </p>
          </div>
          <v-text-field
            v-model="config_project_name_th"
            :label="$t('officer_config.project_name_th')"
            outlined
            dense
            :rules="requiredRules"
          ></v-text-field>
          <v-text-field
            v-model="config_project_name_en"
            :label="$t('officer_config.project_name_en')"
            outlined
            dense
            :rules="requiredRules"
          ></v-text-field>
          <v-autocomplete
            v-model="config_project_number_of_ranks"
            v-bind:label="$t('officer_config.number_of_ranks')"
            v-bind:items="number_of_ranks"
            v-bind:item-value="(item) => item.NUMBER_OF_RANKS"
            v-bind:item-text="(item) => item.NUMBER_OF_RANKS"
            :rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <v-text-field
            v-model="config_application_fee"
            v-bind:label="$t('officer_config.application_fee')"
            outlined
            dense
            :rules="requiredRules"
            type="number"
          >
          </v-text-field>

          <DateSelectCard
            v-model="config_start_application_date"
            v-bind:label="$t('officer_config.start_application_date')"
            v-bind:rules="requiredRules"
            v-bind:maxDate="getYearsModified(5)"
          />
          <DateSelectCard
            v-model="config_end_application_date"
            v-bind:label="$t('officer_config.end_application_date')"
            v-bind:rules="requiredRules"
            v-bind:maxDate="getYearsModified(5)"
          />
          <DateSelectCard
            v-model="config_start_application_pay_date"
            v-bind:label="$t('officer_config.start_application_pay_date')"
            v-bind:rules="requiredRules"
            v-bind:maxDate="getYearsModified(5)"
          />
          <DateSelectCard
            v-model="config_end_application_pay_date"
            v-bind:label="$t('officer_config.end_application_pay_date')"
            v-bind:rules="requiredRules"
            v-bind:maxDate="getYearsModified(5)"
          />
          <DateSelectCard
            v-model="config_start_confirm_date"
            v-bind:label="$t('officer_config.start_confirm_date')"
            v-bind:rules="requiredRules"
            v-bind:maxDate="getYearsModified(5)"
          />
          <DateSelectCard
            v-model="config_end_confirm_date"
            v-bind:label="$t('officer_config.end_confirm_date')"
            v-bind:rules="requiredRules"
            v-bind:maxDate="getYearsModified(5)"
          />
          <DateSelectCard
            v-model="config_start_confirm_pay_date"
            v-bind:label="$t('officer_config.start_confirm_pay_date')"
            v-bind:rules="requiredRules"
            v-bind:maxDate="getYearsModified(5)"
          />
          <DateSelectCard
            v-model="config_end_confirm_pay_date"
            v-bind:label="$t('officer_config.end_confirm_pay_date')"
            v-bind:rules="requiredRules"
            v-bind:maxDate="getYearsModified(5)"
          />
          <v-checkbox
            class="ma-0"
            v-model="config_applicant_can_upload_document"
            v-bind:label="$t('officer_config.applicant_can_upload_file')"
          ></v-checkbox>

          <v-text-field
            v-model="config_url"
            :label="$t('officer_config.attach_URL_if_any')"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="config_remark"
            :label="$t('officer_config.remark_if_any')"
            outlined
            dense
          ></v-text-field>
          <v-file-input
            v-model="config_pdf_file"
            :label="$t('officer_config.attach_PDF_if_any')"
          ></v-file-input>

          <v-checkbox
            class="ma-0"
            v-model="config_enabled"
            v-bind:label="$t('officer_config.enabled')"
          ></v-checkbox>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="form_validate()"
            >{{ $t("officer_config.save") }}
          </v-btn>
          <v-btn color="error" dark @click="showing_modal = false"
            >{{ $t("officer_config.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import { objectTranslator } from "@/helper/translator";
import { getYearsModified } from "@/helper/dateTime";
import { listFilter } from "@/helper/filter";
import validator from "@/helper/validator";
import ConfigProvider from "@/services/config.provider";
import DateSelectCard from "@/components/info_cards/DateSelect";

const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

const FORM_MODES = { ADD: 0, EDIT: 1, COPY: 2 };

export default {
  name: "configProjectAddEditModal",
  props: {
    toggle_loading: Function,
    fetch_data: Function,
  },
  data: function () {
    return {
      FORM_MODES,
      form_mode: null,
      form_status: null,
      showing_modal: false,

      rounds: [],
      years: [],
      number_of_ranks: [1, 2, 3],

      level_id: null,
      config_level_id: null,
      config_year_id: null,
      config_project_id: null,
      config_round_id: null,
      config_project_code: null,
      config_project_name_th: null,
      config_project_name_en: null,
      config_project_number_of_ranks: null,

      config_application_fee: null,
      config_start_application_date: null,
      config_end_application_date: null,
      config_start_application_pay_date: null,
      config_end_application_pay_date: null,
      config_start_confirm_date: null,
      config_end_confirm_date: null,
      config_start_confirm_pay_date: null,
      config_end_confirm_pay_date: null,
      config_applicant_can_upload_document: null,

      config_pdf_file: null,
      config_pdf_exists: null,
      config_url: null,
      config_remark: null,

      config_enabled: null,

      config_from_project_id: null,
      config_from_project_name: null,

      requiredRules: [validator.required],
    };
  },
  components: { DateSelectCard },
  computed: {
    levels() {
      return this.$store.state.ref.levels;
    },
    ...mapOfficerConfigFields({
      config_years: "config_years",
    }),
  },
  methods: {
    listFilter,
    objectTranslator,
    getYearsModified,

    async select_year(year_id) {
      this.toggle_loading(true);
      this.round_id = null;
      const rounds = await configService.getFilteredRounds({ year_id });
      this.rounds = rounds;
      this.toggle_loading(false);
    },

    open_add_modal: async function ({
      rounds,
      years,
      level_id,
      year_id,
      round_id,
    }) {
      this.level_id = level_id;
      this.years = years;
      this.config_level_id = level_id;
      this.rounds = rounds;
      this.form_mode = FORM_MODES.ADD;

      await this.$refs.form.reset();

      this.config_year_id = year_id;
      this.config_round_id = round_id;
      this.config_project_number_of_ranks = 1;

      this.config_pdf_file = null;
      this.config_url = null;
      this.config_remark = null;

      this.config_enabled = true;

      this.showing_modal = true;
    },

    open_edit_modal: function ({ item, rounds }) {
      this.rounds = rounds;
      this.form_mode = FORM_MODES.EDIT;
      this.config_year_id = item.YEAR_ID;
      this.config_level_id = item.LEVEL_ID;
      this.config_round_id = item.ROUND_ID;
      this.config_project_id = item.PROJECT_ID;
      this.config_project_code = item.PROJECT_CODE;
      this.config_project_name_th = item.PROJECT_NAME_TH;
      this.config_project_name_en = item.PROJECT_NAME_EN;
      this.config_project_number_of_ranks = parseInt(item.NUMBER_OF_RANKS);

      this.config_application_fee = item.APPLICATION_FEE;
      this.config_start_application_date = item.START_APPLICATION_DATE;
      this.config_end_application_date = item.END_APPLICATION_DATE;
      this.config_start_application_pay_date = item.START_APPLICATION_PAY_DATE;
      this.config_end_application_pay_date = item.END_APPLICATION_PAY_DATE;
      this.config_start_confirm_date = item.START_CONFIRM_DATE;
      this.config_end_confirm_date = item.END_CONFIRM_DATE;
      this.config_start_confirm_pay_date = item.START_CONFIRM_PAY_DATE;
      this.config_end_confirm_pay_date = item.END_CONFIRM_PAY_DATE;
      this.config_applicant_can_upload_document = parseInt(
        item.APPLICANT_CAN_UPLOAD_DOCUMENT
      );

      this.config_pdf_file = null;
      this.config_url = item.URL;
      this.config_remark = item.REMARK;

      this.config_enabled = parseInt(item.ENABLED);

      this.showing_modal = true;
    },

    open_copy_modal: function ({ item, rounds, level_id, years }) {
      this.level_id = level_id;
      this.years = years;
      this.rounds = rounds;
      this.form_mode = FORM_MODES.COPY;
      this.config_year_id = item.YEAR_ID;
      this.config_level_id = item.LEVEL_ID;
      this.config_round_id = item.ROUND_ID;
      this.config_project_id = item.PROJECT_ID;
      this.config_project_code = item.PROJECT_CODE;
      this.config_project_name_th = null;
      this.config_project_name_en = null;
      this.config_project_number_of_ranks = parseInt(item.NUMBER_OF_RANKS);

      this.config_application_fee = item.APPLICATION_FEE;
      this.config_start_application_date = item.START_APPLICATION_DATE;
      this.config_end_application_date = item.END_APPLICATION_DATE;
      this.config_start_application_pay_date = item.START_APPLICATION_PAY_DATE;
      this.config_end_application_pay_date = item.END_APPLICATION_PAY_DATE;
      this.config_start_confirm_date = item.START_CONFIRM_DATE;
      this.config_end_confirm_date = item.END_CONFIRM_DATE;
      this.config_start_confirm_pay_date = item.START_CONFIRM_PAY_DATE;
      this.config_end_confirm_pay_date = item.END_CONFIRM_PAY_DATE;
      this.config_applicant_can_upload_document = parseInt(
        item.APPLICANT_CAN_UPLOAD_DOCUMENT
      );
      this.config_pdf_exists = item.PROJECT_PDF_EXISTS;
      this.config_url = item.URL;
      this.config_remark = item.REMARK;

      this.config_enabled = parseInt(item.ENABLED);

      this.config_from_project_id = item.PROJECT_ID;
      this.config_from_project_name = `${item.PROJECT_NAME_TH}`;

      this.showing_modal = true;
    },

    form_validate: function () {
      if (this.form_mode === FORM_MODES.ADD) {
        this.add_form_validate();
      } else if (this.form_mode === FORM_MODES.EDIT) {
        this.edit_form_validate();
      } else if (this.form_mode === FORM_MODES.COPY) {
        this.copy_form_validate();
      }
    },

    add_form_validate: async function () {
      this.$refs.form.validate();
      if (this.form_status) {
        this.showing_modal = false;
        this.toggle_loading(true);
        let response = await configService
          .saveProject({
            round_id: this.config_round_id,
            project_code: this.config_project_code,
            project_name_th: this.config_project_name_th,
            project_name_en: this.config_project_name_en,
            number_of_ranks: this.config_project_number_of_ranks,

            application_fee: this.config_application_fee,
            start_application_date: this.config_start_application_date,
            end_application_date: this.config_end_application_date,
            start_application_pay_date: this.config_start_application_pay_date,
            end_application_pay_date: this.config_end_application_pay_date,
            start_confirm_date: this.config_start_confirm_date,
            end_confirm_date: this.config_end_confirm_date,
            start_confirm_pay_date: this.config_start_confirm_pay_date,
            end_confirm_pay_date: this.config_end_confirm_pay_date,
            applicant_can_upload_document: this
              .config_applicant_can_upload_document
              ? 1
              : 0,

            url: this.config_url,
            remark: this.config_remark,

            enabled: this.config_enabled,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });

        if (this.config_pdf_file) {
          if (response && response.status) {
            let upload_response = await configService
              .saveProjectFile({
                FILE: this.config_pdf_file,
                PROJECT_ID: response.inserted_id,
              })
              .catch((error) => {
                this.$toasted.error(
                  JSON.stringify(error.response.data.message),
                  {
                    duration: 0,
                  }
                );
                this.toggle_loading(false);
              });
            if (upload_response.status) {
              this.$toasted.success(this.$t("toasted.create_successfully"));
            } else {
              this.$toasted.error(this.$t("toasted.cannot_upload_file"));
            }
          } else this.$toasted.error(this.$t("toasted.cannot_create"));
        } else {
          if (response && response.status)
            this.$toasted.success(this.$t("toasted.create_successfully"));
          else this.$toasted.error(this.$t("toasted.cannot_create"));
        }
        this.fetch_data(this.config_year_id);
        this.toggle_loading(false);
      }
    },

    edit_form_validate: async function () {
      this.$refs.form.validate();
      if (this.form_status) {
        this.showing_modal = false;
        this.toggle_loading(true);
        let response = await configService
          .editProject({
            round_id: this.config_round_id,
            project_id: this.config_project_id,
            project_code: this.config_project_code,
            project_name_th: this.config_project_name_th,
            project_name_en: this.config_project_name_en,
            number_of_ranks: this.config_project_number_of_ranks,

            application_fee: this.config_application_fee,
            start_application_date: this.config_start_application_date,
            end_application_date: this.config_end_application_date,
            start_application_pay_date: this.config_start_application_pay_date,
            end_application_pay_date: this.config_end_application_pay_date,
            start_confirm_date: this.config_start_confirm_date,
            end_confirm_date: this.config_end_confirm_date,
            start_confirm_pay_date: this.config_start_confirm_pay_date,
            end_confirm_pay_date: this.config_end_confirm_pay_date,
            applicant_can_upload_document: this
              .config_applicant_can_upload_document
              ? 1
              : 0,

            url: this.config_url,
            remark: this.config_remark,

            enabled: this.config_enabled,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });

        if (this.config_pdf_file) {
          if (response && response.status) {
            let upload_response = await configService
              .saveProjectFile({
                FILE: this.config_pdf_file,
                PROJECT_ID: this.config_project_id,
              })
              .catch((error) => {
                this.$toasted.error(
                  JSON.stringify(error.response.data.message),
                  {
                    duration: 0,
                  }
                );
                this.toggle_loading(false);
              });
            if (upload_response.status) {
              this.$toasted.success(this.$t("toasted.edit_successfully"));
            } else {
              this.$toasted.error(this.$t("toasted.cannot_upload_file"));
            }
          } else this.$toasted.error(this.$t("toasted.cannot_create"));
        } else {
          if (response && response.status)
            this.$toasted.success(this.$t("toasted.edit_successfully"));
          else this.$toasted.error(this.$t("toasted.cannot_create"));
        }

        this.fetch_data(this.config_year_id);
        this.toggle_loading(false);
      }
    },

    copy_form_validate: async function () {
      this.$refs.form.validate();
      if (this.form_status) {
        this.showing_modal = false;
        this.toggle_loading(true);
        let response = await configService
          .copyProject({
            round_id: this.config_round_id,

            from_project_id: this.config_from_project_id,

            project_code: this.config_project_code,
            project_name_th: this.config_project_name_th,
            project_name_en: this.config_project_name_en,
            number_of_ranks: this.config_project_number_of_ranks,

            application_fee: this.config_application_fee,
            start_application_date: this.config_start_application_date,
            end_application_date: this.config_end_application_date,
            start_application_pay_date: this.config_start_application_pay_date,
            end_application_pay_date: this.config_end_application_pay_date,
            start_confirm_date: this.config_start_confirm_date,
            end_confirm_date: this.config_end_confirm_date,
            start_confirm_pay_date: this.config_start_confirm_pay_date,
            end_confirm_pay_date: this.config_end_confirm_pay_date,
            applicant_can_upload_document:
              this.config_applicant_can_upload_document,

            pdf_exists: this.config_pdf_exists,
            url: this.config_url,
            remark: this.config_remark,

            enabled: this.config_enabled,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });
        this.fetch_data(this.config_year_id);
        if (response && response.status)
          this.$toasted.success(this.$t("toasted.create_successfully"));
        else this.$toasted.error(this.$t("toasted.cannot_create"));
        this.toggle_loading(false);
      }
    },
  },
};
</script>
